import {
  Box,
  Flex,
  Text,
  Modal,
  ModalContent,
  ModalOverlay,
  Image,
  Button,
  Skeleton,
  TableContainer,
  Table,
  Thead,
  Tr,
  Tbody,
  Td,
} from "@chakra-ui/react";
import React, { memo, useEffect, useState } from "react";
import IconX from "../../../assets/images/booking/x-circle.svg";
import { useForm } from "react-hook-form";
import iconExcel from "../../../assets/images/employee/iconExcel.svg";
import { exportFile, formatDateDb } from "../../../utils/tools";
import toast from "react-hot-toast";
import { formatNumber } from "../../../utils/utils";
import { formatTableValue } from "../formatTable";

const FormDetail = memo(
  ({ isOpen, onClose, defaultValues, isLoading, isRefetching }) => {
    const { reset } = useForm({
      defaultValues: defaultValues || {},
    });

    const [data, setData] = useState([]);

    useEffect(() => {
      reset(defaultValues);
      if (defaultValues?.item) {
        const result = defaultValues?.item
          ?.filter((item) => item.period !== 0)
          .map((item) => ({
            time: item.calculateDate ? formatDateDb(item.calculateDate) : "-",
            period: item.period ?? "-",
            project: item.locking?.projectObject?.name ?? "-",
            apartment: item.locking?.apartmentObject?.code ?? "-",
            price: item.price
              ? `${formatNumber(Number(item.price))} VNĐ`
              : "0 VNĐ",
            serviceFee: item.serviceFee
              ? `${formatNumber(Number(item.serviceFee))} VNĐ`
              : "0 VNĐ",
          }));

        setData(result);
      }
    }, [isOpen]);

    const code = defaultValues?.code || "";
    const fullName = defaultValues?.fullName || "";
    const employeeData = code + "-" + fullName;

    const tableData = {
      headers: [
        {
          label: "Thời gian",
          key: "time",
        },
        {
          label: "Đợt",
          key: "period",
        },
        {
          label: "Dự án",
          key: "project",
        },
        {
          label: "Mã căn",
          key: "apartment",
        },
        {
          label: "Giá trị niêm yết",
          key: "price",
        },
        {
          label: "Phí dịch vụ",
          key: "serviceFee",
        },
      ],
      data: data,
    };

    const handleExport = () => {
      const columnMapping = {
        time: "Thời gian",
        project: "Dự án",
        apartment: "Mã căn",
        price: "Giá trị niêm yết",
        serviceFee: "Phí dịch vụ",
      };
      const dataEx = data.map((item) => ({
        time: item.time,
        project: item.project,
        apartment: item.apartment,
        price: item.price,
        serviceFee: item.serviceFee,
      }));
      if (dataEx && dataEx?.length) {
        exportFile(
          dataEx,
          columnMapping,
          `bang_chi_tiet_phi_dich_vu_${defaultValues?.fullName}_${defaultValues?.time}.xlsx`
        );
        toast.success("Download file thành công");
      } else toast.error("Không có dữ liệu");
    };

    return (
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent
          backgroundColor="var(--color-main)"
          borderRadius={"16px"}
          position={"relative"}
          w={"100%"}
          maxW={"925px"}
        >
          <Box
            paddingBottom={"80px"}
            h={"86.5vh"}
            w={"100%"}
            overflowY={"scroll"}
            sx={{
              "&::-webkit-scrollbar": {
                width: "4px",
              },
              "&::-webkit-scrollbar-thumb": {
                width: "4px",
                borderRadius: "50px",
                background: "var(--color-background)",
              },
              "&::-moz-scrollbar": {
                width: "4px",
              },
              "&::-moz-scrollbar-thumb": {
                width: "4px",
                borderRadius: "50px",
                background: "var(--color-background)",
              },
            }}
          >
            <Flex
              alignItems={"center"}
              p={"25px 24px 24px 24px"}
              position={"relative"}
              borderBottom={"1px solid var(--border-input-employee)"}
            >
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"16px"}
                fontWeight={"600"}
              >
                Bảng tính phí dịch vụ chi tiết
              </Text>
              <Box
                position={"absolute"}
                top={"24px"}
                right={"24px"}
                cursor={"pointer"}
                onClick={onClose}
              >
                <Image src={IconX} />
              </Box>
            </Flex>
            <Box margin={"0 auto"}>
              <Box p={"16px 24px"}>
                <Flex justifyContent={"space-between"} alignItems={"center"}>
                  <Text color={"var(--color-header-employee)"} fontWeight={600}>
                    {employeeData}
                  </Text>
                  <Button
                    display={"flex"}
                    alignItems={"center"}
                    p={"10px 16px 10px 12px"}
                    gap={"8px"}
                    h={"44px"}
                    backgroundImage="var(--linear-gradient-excel)"
                    _hover={{
                      filter: "brightness(90%)",
                    }}
                    onClick={handleExport}
                  >
                    <Image src={iconExcel} />
                    <Text
                      fontSize={{ base: "15px" }}
                      fontWeight={600}
                      color="var(--color-main)"
                    >
                      Xuất excel
                    </Text>
                  </Button>
                </Flex>
              </Box>
              <Box p={"16px 40px 24px 40px"}>
                <Box border="1px solid var(--color-black-2)" borderRadius="8px">
                  <Flex alignItems={"center"} justifyContent={"space-between"}>
                    <Text fontWeight="600" padding={"16px 12px"}>
                      {defaultValues?.time || ""}
                    </Text>
                    <Flex
                      alignItems={"center"}
                      gap={"12px"}
                      padding={"16px 12px"}
                    >
                      <Text color={"var(--color-black-4)"}>Tổng PDV :</Text>
                      <Text color={"var(--color-option-employee-hover)"}>
                        {defaultValues?.serviceFee || ""}
                      </Text>
                    </Flex>
                  </Flex>
                  <Skeleton isLoaded={!isLoading && !isRefetching}>
                    <TableContainer
                      w={"100%"}
                      maxH="calc(100vh - 350.5px)"
                      overflowY="auto"
                    >
                      <Table w={"100%"} variant="unstyled">
                        <Thead
                          position="sticky"
                          top="0"
                          zIndex="1"
                          w={"100%"}
                          h={"41px"}
                          color="white"
                          fontWeight="400"
                          backgroundColor="#F9FAFD"
                        >
                          <Tr h={{ base: "41px" }}>
                            {tableData.headers.map((e, index) => {
                              let width = "auto";
                              let textAlign = "auto";
                              if (e.key === "") {
                                width = "2%";
                                textAlign = "center";
                              } else if (e.key === "time") {
                                width = "10%";
                                textAlign = "start";
                              } else if (e.key === "period") {
                                width = "10%";
                                textAlign = "start";
                              } else if (e.key === "apartment") {
                                width = "10%";
                                textAlign = "start";
                              } else if (e.key === "project") {
                                width = "30%";
                                textAlign = "start";
                              } else if (e.key === "price") {
                                width = "10%";
                                textAlign = "start";
                              } else {
                                width = "10%";
                                textAlign = "end";
                              }
                              return (
                                <Td
                                  p={"16px 16px 8px 16px"}
                                  key={index}
                                  border={"none"}
                                  color={"#51607B"}
                                  fontSize={{ base: "14px" }}
                                  w={width}
                                >
                                  <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                                </Td>
                              );
                            })}
                          </Tr>
                        </Thead>
                        <Tbody
                          w={"100%"}
                          h={"100%"}
                          borderBottom={"1px solid var(--color-black-2)"}
                          borderTop={"1px solid var(--color-black-2)"}
                        >
                          {tableData.data?.length > 0 ? (
                            tableData.data?.map((e, rowIndex) => {
                              const items = { ...e };
                              delete items.id;
                              delete items.edit;
                              delete items.detail;
                              const keyValues = Object.keys(items);
                              return (
                                <Tr key={rowIndex} h={"72px"}>
                                  {keyValues.map((keyvalue, index) => {
                                    let width = "auto";
                                    let widthText = "100%";
                                    let textAlign = "auto";
                                    let whiteSpace = "inherit";
                                    if (keyvalue === "") {
                                      width = "2%";
                                      textAlign = "center";
                                    } else if (keyvalue === "code") {
                                      width = "5%";
                                      textAlign = "start";
                                    } else if (keyvalue === "project") {
                                      width = "30%";
                                      textAlign = "start";
                                    } else if (keyvalue === "period") {
                                      width = "10%";
                                      textAlign = "start";
                                    } else if (keyvalue === "apartment") {
                                      width = "10%";
                                      textAlign = "start";
                                    } else if (keyvalue === "price") {
                                      width = "10%";
                                      textAlign = "start";
                                    } else if (keyvalue === "time") {
                                      width = "10%";
                                      textAlign = "start";
                                    } else {
                                      width = "10%";
                                      textAlign = "end";
                                      whiteSpace = "inherit";
                                    }
                                    return (
                                      <Td
                                        p={"16px 16px 8px 16px"}
                                        w={width}
                                        key={index}
                                      >
                                        <Box
                                          fontSize={{ base: "14px" }}
                                          lineHeight={"19.6px"}
                                          textAlign={"start"}
                                          fontWeight={500}
                                          color={"var(--color-info-employee)"}
                                          w={widthText}
                                          whiteSpace={whiteSpace}
                                          overflow="hidden"
                                          textOverflow="ellipsis"
                                          display="-webkit-box"
                                          sx={{
                                            WebkitLineClamp: "2",
                                            WebkitBoxOrient: "vertical",
                                          }}
                                        >
                                          {formatTableValue(
                                            e[keyvalue],
                                            keyvalue
                                          )}
                                        </Box>
                                      </Td>
                                    );
                                  })}
                                </Tr>
                              );
                            })
                          ) : (
                            <Tr>
                              <Td
                                colSpan={tableData.headers.length}
                                textAlign="center"
                                padding={"40px 0"}
                              >
                                Không có dữ liệu
                              </Td>
                            </Tr>
                          )}
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </Skeleton>
                </Box>
              </Box>
            </Box>
          </Box>
        </ModalContent>
      </Modal>
    );
  }
);

export default FormDetail;
